import { useTranslation } from "react-i18next";
import { useStatusModal } from "shared/core/hooks/useStatusModal";
import { useCallback, useEffect, useMemo } from "react";
import { useSSO } from "../../../../../hooks/useSSO/useSSO";
import { EventNames } from "core/monitoring/types/enums";
import { trackClientCodeConflicts } from "core/monitoring/Events";

interface SsoChangeCodeModalProps {
  isVisible: boolean;
  onDismiss: () => void;
}

export const SsoChangeCodeModal = ({ isVisible, onDismiss }: SsoChangeCodeModalProps) => {
  const { signedUpWithSso, hasSetupSso } = useSSO();
  const { t } = useTranslation(undefined, { keyPrefix: "accountSecurity.home.organizationCode" });
  const { setBody, Modal: StatusModal } = useStatusModal("sso-change-code");

  const modalTranslationKey = useMemo(() => (hasSetupSso && !signedUpWithSso ? "ssoSignInAlert" : "ssoSignUpAlert"), [hasSetupSso, signedUpWithSso]);

  const handleConfirmation = useCallback(() => onDismiss(), [onDismiss]);

  useEffect(() => {
    trackClientCodeConflicts(EventNames.SSO_CLIENT_CODE_CONFLICT_CHANGE_ORG_BLOCKED, signedUpWithSso, hasSetupSso);
  }, [signedUpWithSso, hasSetupSso]);

  useEffect(() => {
    setBody({
      data: t(modalTranslationKey, { returnObjects: true }),
      status: "info",
      callback: handleConfirmation,
    });
  }, [modalTranslationKey, handleConfirmation, onDismiss, setBody, t, isVisible]);

  if (!isVisible) {
    return null;
  }

  return StatusModal;
};
